import { put, call } from "redux-saga/effects";
import log from "loglevel";
import * as services from "./service";
import * as types from "./types";
import * as actions from "./action";
import { toastr } from "react-redux-toastr";

/* YardSight-specific Sagas */
export function* ymsDeckingOptimizationTesterSaga(
  action: types.YmsDeckingOptimizationTesterActionType
) {
  try {
    const response = yield call(
      services.ymsDeckingOptimizationTesterService,
      action.payload
    );
    if (response.data) {
      log.info("ymsDeckingOptimizationTesterSaga: GOOD!");
      yield put({
        type: actions.YMS_DECKING_OPTIMIZATION_TESTER_SUCCESS,
        response,
      });
      toastr.success("Decking Optimization Test Sent", "Success");
    } else if (response.error) {
      throw response;
    } else {
      log.info("ymsDeckingOptimizationTesterSaga: BAD!");
      throw response;
    }
  } catch (error) {
    yield put({
      type: actions.YMS_DECKING_OPTIMIZATION_TESTER_ERROR,
      response: error,
    });
    toastr.error(
      "Decking Optimization Test Not Sent",
      `${error.error.message}`
    );
  }
}

export function* ymsDeckingFilterSaga(
  action: types.YmsDeckingFilterActionType
) {
  try {
    const response = yield call(
      services.ymsDeckingFilterService,
      action.payload
    );
    if (response.data) {
      log.info("ymsDeckingFilterSaga: GOOD!");
      yield put({ type: actions.YMS_DECKING_FILTER_SUCCESS, response });
      toastr.success("Decking Filter Sent", "Success");
    } else if (response.error) {
      throw response;
    } else {
      log.info("ymsDeckingFilterSaga: BAD!");
      throw response;
    }
  } catch (error) {
    yield put({ type: actions.YMS_DECKING_FILTER_ERROR, response: error });
    toastr.error("Decking Filter Not Sent", `${error.error.message}`);
  }
}
